@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

[data-fpsm-theme='gazzetta'] {
  .tabsTrigger[data-variant='default'] {
    color: var(--cxy-color-text-default-body);
    font-weight: var(--cxy-fontWeight-normal);

    &:hover {
      color: var(--cxy-color-text-default-body);
    }

    &:focus {
      color: var(--cxy-color-text-default-body);
    }

    &[data-state='active'] {
      color: var(--cxy-color-text-default-body);
      border-bottom: 2px solid var(--cxy-color-content-default);
      font-weight: var(--cxy-fontWeight-bold);
    }
  }
}

.tabsList {
  @include cxy.font-size('subHeading-s');
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  &[data-variant='default'] {
    @media (min-width: 768px) {
      display: inline-flex;
      justify-content: start;
      width: auto;
    }
  }

  &[data-variant='block'] {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-bottom: var(--cxy-spacing-sm);

    > div {
      display: inline-flex;
      background: transparent;
      border: 1px solid #87a5b8;
      border-radius: 8px;
      padding: var(--cxy-spacing-xxxsm);
      margin: 0 auto;

      > [role='tablist'] {
        display: inline-flex;
        flex-direction: row;
      }
    }
  }
}

.tabsTrigger {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  @include cxy.font-size('subHeading-s', var(--cxy-fontWeight-semiBold));
  background: transparent;
  border: none;
  padding: var(--cxy-spacing-3) var(--cxy-spacing-xxsm);
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:focus-visible {
    @include cxy.focus-ring;
  }

  &[data-variant='default'] {
    color: var(--cxy-color-content-subtle);
    transition:
      color 0.2s,
      border-color 0.2s;
    border-block-end: 2px solid transparent;
    margin-bottom: var(--cxy-spacing-xxsm);

    &:hover {
      color: var(--cxy-color-brand);
    }

    &:focus {
      color: var(--cxy-color-brand);
    }

    &[data-state='active'] {
      color: var(--cxy-color-brand);
      border-bottom: 2px solid var(--cxy-color-brand);
    }

    @media (min-width: 768px) {
      flex: 0 1 auto;
      min-width: 130px;
      padding: var(--cxy-spacing-3) var(--cxy-spacing-xsm);
    }
  }

  &[data-variant='block'] {
    @include cxy.font-size('body-l');
    color: white;
    border-radius: 6px;
    padding: var(--cxy-spacing-3) var(--cxy-spacing-sm);
    transition: all 0.2s;
    min-width: 120px;
    margin: 0;
    flex: 0 1 auto;

    &:hover {
      color: rgba(255, 255, 255, 0.8);
    }

    &:focus {
      color: rgba(255, 255, 255, 0.8);
    }

    &[data-state='active'] {
      color: var(--cxy-color-text-default-placeholder);
      background: var(--cxy-color-brand);
    }
  }
}

.tabsContent {
  margin-top: var(--cxy-spacing-xsm);

  &:focus {
    outline: none;
  }
}

.fullWidth {
  &.tabsList {
    &[data-variant='default'] {
      @media (min-width: 768px) {
        width: 100%;
      }
    }
  }
  .tabsTrigger {
    &[data-variant='default'] {
      @media (min-width: 768px) {
        flex: 1;
      }
    }
  }
}
